// probably timing problem with lit: https://github.com/lit/lit/blob/7453e365000e6a289c139cf7e175a4742296333d/packages/reactive-element/src/css-tag.ts#L10
// if lit is loaded before style sheet it cannot handle CSSStyleSheets from AdornisCSS
import type { Maybe } from '@adornis/base/utilTypes';
import { BaseQLClient } from '@adornis/baseql/client/baseqlClient.js';
import type { LASUser } from '@adornis/digitale-helden-shared/db/las-user';
import { translations } from '@adornis/digitale-helden-shared/db/translation';
import { registerAnchorDetection } from '@adornis/digitale-helden-shared/features/anchoring/client/registerAnchorDetection';
import '@adornis/fonts/fontSrc/lato.js';
import '@adornis/fonts/fontSrc/maven-pro.js';
import '@adornis/fonts/fonts';
import { clientTranslator } from '@adornis/translation-core/client/clientTranslator';
import { currentUser, subscribeCurrentUser } from '@adornis/users/client/currentUser.js';
import 'construct-style-sheets-polyfill'; // THIS HAS TO BE THE FIRST IMPORT FOR FIREFOX TO WORK CORRECTLY
import '../db';
import './main-element.js';

BaseQLClient.initDefault();

export let loggedInUser: Maybe<LASUser> = null;
currentUser<LASUser>().subscribe(user => {
  loggedInUser = user;
});

subscribeCurrentUser().catch(e => console.error('There was an error subscribing current user: ', e));
clientTranslator.updateDictionary(translations);

// theme (order is important)
// init theme
import './theme/index';
// create components
import './theme/defaults/index';

registerAnchorDetection();
